module.exports = __webpack_public_path__ + "static/media/poster_Bennington.cb9663c0.png";